import React from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { SplitProgressBar } from 'uiToolkitV1/ProgressBar';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const COLOR_MAP = {
  BELONGING: { barColor: '#ACBAFF' },
  PERFORMANCE: { barColor: '#FFDE88' },
  COLLABORATION: { barColor: '#FD9B9B' },
  GROWTH: { barColor: '#B1E39F' },
  MANAGER_EFFECTIVENESS: { barColor: '#FFB6FC' },
};

const TEXT_MAP = {
  BELONGING: 'Belonging',
  PERFORMANCE: 'Performance',
  COLLABORATION: 'Collaboration',
  GROWTH: 'Growth',
  MANAGER_EFFECTIVENESS: 'Manager effectiveness',
};

const TEXT_COLOR_MAP = {
  BELONGING: '#7651BC',
  PERFORMANCE: '#8C6A00',
  COLLABORATION: '#C62C02',
  MANAGER_EFFECTIVENESS: '#7D1779',
  GROWTH: '#44812F',
};

const transformDataForProgressBar = (data) =>
  Object.entries(data)?.map(([key, value]) => ({
    label: TEXT_MAP[key],
    weight: value,
    color: COLOR_MAP[key].barColor,
  }));

const ThemeDistributionColumn = (params) => {
  const { value: topicDistributionData } = params?.data?.themeDistribution ?? {};
  const transformedData = transformDataForProgressBar(topicDistributionData ?? {});
  const totalWeight = Object.values(topicDistributionData ?? {})?.reduce((acc, value) => acc + value, 0);

  if (transformedData?.length === 0) {
    return (
      <Flex w="100%" h="100%" alignItems="center">
        <TextBodyMedium color="#333333">NA</TextBodyMedium>
      </Flex>
    );
  }

  return (
    <Box mt="30px">
      <SplitProgressBar size="large" data={transformedData} totalWeight={totalWeight} percentageValue={false} />
      <Flex flexDirection="column">
        {Object.keys(topicDistributionData).map((key, index) => {
          if (index % 2 === 0) {
            const belongingPercentage = Math.round(topicDistributionData[key]);
            const nextKey = Object.keys(topicDistributionData)[index + 1];
            const performancePercentage = nextKey ? Math.round(topicDistributionData[nextKey]) : null;

            return (
              <Flex key={key} w="100%">
                <Flex mr="8px" justifyContent="space-between">
                  <TextLabel
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                    }}
                    color={TEXT_COLOR_MAP[key]}
                  >
                    {TEXT_MAP[key]}
                  </TextLabel>
                  <TextLabel
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                    }}
                    color={TEXT_COLOR_MAP[key]}
                  >
                    : {belongingPercentage}%
                  </TextLabel>
                </Flex>
                {performancePercentage && (
                  <Flex>
                    <TextLabel
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                      color={TEXT_COLOR_MAP[nextKey]}
                    >
                      {TEXT_MAP[nextKey]}
                    </TextLabel>
                    <TextLabel
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                      color={TEXT_COLOR_MAP[nextKey]}
                    >
                      : {performancePercentage}%
                    </TextLabel>
                  </Flex>
                )}
              </Flex>
            );
          }
          return null;
        })}
      </Flex>
    </Box>
  );
};

export default ThemeDistributionColumn;
